/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  PersonResponse,
  UpdatePersonRequest
} from '.././model';

import { customCatchBackendFetcher } from '../../../client/customFetcher';




/**
 * Get the authenticated user's person information
 * @summary Get Me
 */
export const getMeV1PersonsMeGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customCatchBackendFetcher<PersonResponse>(
      {url: `/v1/persons/me`, method: 'GET', signal
    },
      );
    }
  

export const getGetMeV1PersonsMeGetQueryKey = () => {
    return [`/v1/persons/me`] as const;
    }

    
export const getGetMeV1PersonsMeGetQueryOptions = <TData = Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeV1PersonsMeGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeV1PersonsMeGet>>> = ({ signal }) => getMeV1PersonsMeGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMeV1PersonsMeGetQueryResult = NonNullable<Awaited<ReturnType<typeof getMeV1PersonsMeGet>>>
export type GetMeV1PersonsMeGetQueryError = unknown


export function useGetMeV1PersonsMeGet<TData = Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeV1PersonsMeGet>>,
          TError,
          Awaited<ReturnType<typeof getMeV1PersonsMeGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMeV1PersonsMeGet<TData = Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeV1PersonsMeGet>>,
          TError,
          Awaited<ReturnType<typeof getMeV1PersonsMeGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMeV1PersonsMeGet<TData = Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Me
 */

export function useGetMeV1PersonsMeGet<TData = Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeV1PersonsMeGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMeV1PersonsMeGetQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update the authenticated user's person information
 * @summary Update Me
 */
export const updateMeV1PersonsMePatch = (
    updatePersonRequest: UpdatePersonRequest,
 ) => {
      
      
      return customCatchBackendFetcher<PersonResponse>(
      {url: `/v1/persons/me`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePersonRequest
    },
      );
    }
  


export const getUpdateMeV1PersonsMePatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMeV1PersonsMePatch>>, TError,{data: UpdatePersonRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateMeV1PersonsMePatch>>, TError,{data: UpdatePersonRequest}, TContext> => {

const mutationKey = ['updateMeV1PersonsMePatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMeV1PersonsMePatch>>, {data: UpdatePersonRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateMeV1PersonsMePatch(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMeV1PersonsMePatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateMeV1PersonsMePatch>>>
    export type UpdateMeV1PersonsMePatchMutationBody = UpdatePersonRequest
    export type UpdateMeV1PersonsMePatchMutationError = HTTPValidationError

    /**
 * @summary Update Me
 */
export const useUpdateMeV1PersonsMePatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMeV1PersonsMePatch>>, TError,{data: UpdatePersonRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMeV1PersonsMePatch>>,
        TError,
        {data: UpdatePersonRequest},
        TContext
      > => {

      const mutationOptions = getUpdateMeV1PersonsMePatchMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    